import classNames from 'classnames';
import sdk from '@/sdk';

import routers, {buildPath} from '@/config/routers';
import {openUrlOnNewWindow} from '@/utils/browserUtils';
import {feLogger, clickCreatorReport} from '@/buried';

import styles from './index.module.scss';
import {isDemissionUser} from '@/utils/user';
import ExternalLabel from '@/components/ExternalLabel';

export const useCardViewUpdate = () => {

    // 点击跳转到个人主页
    const handleJumpPersonalHome = (avatar: string) => {
        return () => {
            const path = buildPath(routers.PersonalHome.path, {
                userName: avatar || '',
            });
            feLogger(clickCreatorReport());
            openUrlOnNewWindow(path);
        };
    };

    const renderUpdateList = async (listData: any) => {
        try {
            const getListData = listData.slice(0, 200);
            const usersList = await sdk.as.getUserInfoList(getListData.map((item: any) => item.uid), false);
            usersList.map((item: any) => {
                getListData.forEach((data: any) => {
                    if (data.uid === item.userGuid) {
                        item.formattedTime = data.formattedTime;
                        item.time = data.time;
                    }
                });
                return item;
            });
            // 按照时间排序后渲染
            usersList.sort((a: any, b: any) => b.time - a.time);
            return (
                <div className={styles.updateBox}>
                    <div className={styles.popperWrapper}>
                        {usersList.map((data: any, index: number) => {
                            return (
                                <div
                                    className={styles.listWrapper}
                                    onClick={handleJumpPersonalHome(data.avatar)}
                                    key={data.userGuid}
                                >
                                    <div className={styles.headBox}>
                                        <img
                                            className={styles.headIcon}
                                            src={data.avatarUrl}
                                        />
                                    </div>
                                    <div className={styles.info}>
                                        <div className={styles.infoTop}>
                                            <div className={styles.infoTopLeft}>
                                                <div className={styles.infoName}>
                                                    {data.nickname}{isDemissionUser(data?.resignStatus)}
                                                </div>
                                                {
                                                    data.external
                                                        ? <ExternalLabel
                                                            labelName={'外部'}
                                                            className={styles.externalLabel}
                                                        />
                                                        : null
                                                }
                                                <div className={classNames(
                                                    styles.infoCard,
                                                    index === 0 && styles.infoCardUpdate
                                                )}
                                                >{index === 0 && '最近编辑者'}</div>
                                            </div>
                                            <div className={styles.infoTopRight}>
                                                {data.formattedTime}
                                            </div>
                                        </div>
                                        <div className={styles.infoBottom}>
                                            <div className={styles.departmentInfo}>{data.department}</div>
                                            <div>{data?.external ? data?.passportDisplayName : data.email}</div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }
        catch (e) {
            return null;
        }
    };

    return {renderUpdateList};
};
